// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"c296571d","162":"4c71f029","1824":"1cec5245","6451":"cc2677aa","7242":"1f1cd215","8122":"30389c25","8908":"8f12d3a5","9576":"366bd4d5"}[chunkId] + ".chunk.css";
};